module.exports = __webpack_public_path__ + "img/8.c05b6bc0.png";